import React, { useState } from 'react';
import Sidebar from '../Sidebar';
import { useAuth } from '../../context/AuthContext';

const Header = () => {
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const { isAuthenticated } = useAuth();

    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
    };

    return (
        <>
            <header className="bg-black text-white p-4 shadow-md flex items-center justify-between relative">
                {/* Logo */}
                <div className="flex items-center">
                    <img src="/logo.png" alt="NetPoints Logo" className="h-16" />
                </div>

                {/* Hamburger and Sidebar only if authenticated */}
                {isAuthenticated && (
                    <>
                        <div className="absolute right-10 flex items-center">
                            <button onClick={toggleSidebar} className="p-2 text-white bg-black rounded ml-4">
                                ☰
                            </button>
                        </div>
                        <Sidebar isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
                        <div className={`backdrop ${isSidebarOpen ? 'show' : ''}`} onClick={toggleSidebar}></div>
                    </>
                )}
            </header>
        </>
    );
};

export default Header;
